import HTMLReactParser from "html-react-parser";
import React, { useEffect, useRef } from "react";
import { sort } from "ramda";
import { setSameHeight, setSameWidth } from "../../../lib/elementUtilities";
import { systemClass } from "../../../lib/enums";
import buildings from "../../../assets/images/buildings/buildings";
import { SlotType } from "../../../lib/types";

interface IProps {
  chainBuildings: SlotType[];
  selectedBuilding: number;
}

const BuildingChainDetail = ({ chainBuildings, selectedBuilding }: IProps) => {
  const buildingsRowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSameWidth(buildingsRowRef.current || undefined);
    setSameHeight(buildingsRowRef.current || undefined);
  }, [chainBuildings]);

  return (
    <section className="boxes-group" style={{ width: "100vw" }}>
      <div className="box" style={{ overflowX: "auto" }}>
        <div className="persons row" ref={buildingsRowRef} style={{ display: "inline-flex" }}>
          {
            Object.values(sort((b1, b2) => b1.level - b2.level, chainBuildings))
              .map((building, index) => (
                <>
                  <div className={"col-sm-6"}>
                      <span className={
                        `person ${systemClass.MatchHeight} ${systemClass.MatchWidth} ${selectedBuilding === building.id
                          ? "selected"
                          : ""}`} style={{ minWidth: "max-content" }}>
                        <img
                          src={buildings[`b${building.imageId}`]}
                          width={"100px"}
                          height={"107px"}
                          alt=""
                          className="photo"
                        />
                        <h3 className="name">
                          {building.name}
                        </h3>
                        <p>
                          {HTMLReactParser(building.descriptionLong)}
                        </p>
                        {/* <p> */}
                        {/*  <span className="white"> */}
                        {/*    <em>{slotPrices[building.id].gold}</em>&nbsp; */}
                        {/*    <i className={"icon icon-xs icon-zlato gold middle"}/> */}
                        {/*    + <em>{slotPrices[building.id].bricks}</em>&nbsp; */}
                        {/*    <i className={"icon icon-xs icon-infrastrukturni-body middle"}/> */}
                        {/*  </span><br/> */}
                        {/*  {building.turns} turns */}
                        {/* </p> */}
                        {/* {building.prerequisities && <p> */}
                        {/*  Requires:<br/> */}
                        {/*  {building.prerequisities} */}
                        {/* </p>} */}
                      </span>
                  </div>
                  {index + 1 < Object.values(chainBuildings).length
                  && <div style={{ display: "flex", alignItems: "center" }}>
                    <i className={"icon icon-sipka-dlouha-r icon-xlg-centered middle"}/>
                  </div>}
                </>))
          }
        </div>
      </div>
    </section>
  )
}

export default BuildingChainDetail;
